import type { Distance } from "@pdfking/math"
import { ZERO_DISTANCE } from "@pdfking/math/constants"

import type { FolderCorner } from "#internal"

/** A corner of a die's outline at `x`, `y`, rounded `radius`. */
export const FolderAt = (
  x: Distance,
  y: Distance,
  radius: Distance = ZERO_DISTANCE
): FolderCorner => ({
  x,
  y,
  radius,
})
